import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import DotOutlined from '@material-ui/icons/FiberManualRecordOutlined';
import Dot from '@material-ui/icons/FiberManualRecord';

import MuiCheckbox from '@material-ui/core/Checkbox';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
});

function DotCheckbox({
  className, classes, value, style, ...rest
}) {
  return (
    <MuiCheckbox
      className={classNames(classes.root, className)}
      icon={<DotOutlined />}
      checkedIcon={<Dot />}
      classes={{
        root: classes.root,
      }}
      variant="outlined"
      checked={value}
      {...rest}
    />
  );
}

DotCheckbox.defaultProps = {
  className: '',
};

DotCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles, { name: 'DotCheckbox' })(DotCheckbox);
